var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("validation-provider", {
        ref: "validation",
        attrs: { rules: _vm.validationRules, name: _vm.label, mode: "eager" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var errors = ref.errors
              return [
                _vm.label
                  ? _c("Label", {
                      staticClass: "mb-25px",
                      attrs: { label: _vm.label, obrigatorio: _vm.isRequired }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("trumbowyg", {
                  attrs: { config: _vm.config, placeholder: _vm.placeholder },
                  on: { "tbw-blur": _vm.onBlur },
                  model: {
                    value: _vm.modelValue,
                    callback: function($$v) {
                      _vm.modelValue = $$v
                    },
                    expression: "modelValue"
                  }
                }),
                _vm._v(" "),
                errors.length > 0
                  ? _c("span", { staticClass: "help erro" }, [
                      _vm._v(" " + _vm._s(errors[0]))
                    ])
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3055334b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3055334b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Forms/InputTextEditor/InputTextEditor.vue
// module id = null
// module chunks = 